export default __webpack_public_path__ + "static/media/external.7b4d4fa9.svg";